import script from "./ProgramPrototypeDesignModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgramPrototypeDesignModal.vue?vue&type=script&setup=true&lang=ts"

import "./ProgramPrototypeDesignModal.vue?vue&type=style&index=0&id=5d228b4c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d228b4c"]])

export default __exports__